import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";

const PreguntasResponsabilidadManejoVehiculo = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasResponsabilidadManejoVehiculo();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Responsabilidad y manejo del vehículo (3/6)"
			opciones={[
				{ key: "conservaVehiculoBuenEstado", label: "Conserva el vehículo en buen estado de limpieza y cuidado" },
				{ key: "reportaOportunamenteFallas", label: "Reporta oportunamente fallas mecánicas o mantenimientos necesarios" },
				{ key: "cumpleLasNormasTransito", label: "Cumple con las normas de tránsito según reportes o historial" },
				{ key: "noHaTenidoIncidentesPornegligencia", label: "No ha tenido incidentes por negligencia o uso inadecuado del vehículo" }
			]}
		/>
	);
};

export default PreguntasResponsabilidadManejoVehiculo;
